<template>
  <div class="box-select-container">
    <button :disabled="option.isDisabled" class="box-select-option btn"
         :class="isSelected(option.id) ? 'btn-success' : 'btn-outline-dark'"
         @click="select(option.id)"
         v-for="option in options">
      <span>{{ option.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "BoxSelect",
  props: {
    options: Array, // id, label, idDisabled
    value: [String, Number]
  },
  data() {
    return {
      realValue: this.value
    }
  },
  watch: {
    value() {
      this.realValue = this.value;
    }
  },
  methods: {
    select(value) {
      this.realValue = value;
      this.$emit('input', value)
    },
    isSelected(id) {
      return this.realValue === id;
    }
  }
}
</script>

<style scoped>
  .box-select-container {

  }
  .box-select-option span {
    vertical-align: bottom;
    vertical-align: sub;
  }

  .box-select-option {
    min-width: 42px;
    margin-left: 5px;
    position: relative;
  }

  .box-select-option:disabled:after {
    content: ' ';
    position: absolute;
    top: 50%;
    left: -20%;
    width: 137%;
    height: 1.4px;
    background: red;
    transform: rotate(
        45deg
    );
  }
  .box-select-option:disabled:before {
    content: ' ';
    position: absolute;
    top: 50%;
    left: -20%;
    width: 137%;
    height: 1.4px;
    background: red;
    transform: rotate(
        -45deg
    );
  }
</style>
